import React from 'react'
import phoneImg from '../assets/img/phone-img.png'
import QR from '../assets/img/QR-code-app.png'
import { FaApple } from "react-icons/fa";
import { FaGooglePlay } from "react-icons/fa6";
import { TfiAndroid } from "react-icons/tfi";
import { SlArrowRight } from "react-icons/sl";


export const TradeApp = () => {
  return (
    <div id="trade-app">
        <div className="container">
            <div className="trade-app">
                <div className="heading app-heading">
                    <h1>Торгуйте везде с приложением NEO BIT</h1>
                </div>
                <div className="app-download">
                    <div className="app-download-img">
                        <img src={phoneImg} alt="" className='app-phone-img'/>
                    </div>
                    <div className="app-download-wrapper">
                        <div className="app-download-upper">
                            <div className="app-download-others">
                                другие варианты <SlArrowRight size={16}/>
                            </div>
                            <div className="multiplier app-download-lite">Сначала авторизуйтесь в приложении или в <a href="#">Lite App</a>, чтобы получить 1USDT</div>
                        </div>
                        <div className="app-download-qr">
                            <img src={QR} alt="" className='qr-code'/>
                            <div className="add-download-txt">
                                <span>Отсканируйте для загрузки приложения</span>
                                <h3>iOS и Android</h3>
                            </div>
                        </div>
                        <div className="app-download-ways">
                            <a href="https://www.apple.com/app-store/" target='_blank'>
                                <div className="download-btn"><FaApple/>App Store</div>
                            </a>
                            <a href="https://play.google.com/store/apps" target='_blank'>
                                <div className="download-btn"><FaGooglePlay/>Google Play</div>
                            </a>
                            <a href="#">
                                <div className="download-btn"><TfiAndroid/>APK</div>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
  )
}
